import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import CheckBox from 'chameleon/ui-stack/ui/base/checkbox';

const JstorConfirmModal = ({ onClose, onSuccess, alreadyAgreed }) => {
  const [isPrimaryBtnDisabled, setIsPrimaryBtnDisabled] =
    useState(!alreadyAgreed);
  const className = 'leading-[23.2px] text-gray-700';

  const onCheckboxClick = (isChecked) => {
    setIsPrimaryBtnDisabled(!isChecked);
  };

  const bottomLeftContent = alreadyAgreed ? null : (
    <div className="mr-auto flex gap-2 items-center">
      <CheckBox
        noDesc
        data-test-id="ack-terms"
        data-cy="ack-terms"
        onClick={onCheckboxClick}
        accessibility={{
          ariaLabelledBy: 'agree-ts',
        }}
      />{' '}
      <label id="agree-ts" className="text-gray-700">
        I agree
      </label>
    </div>
  );
  return (
    <ConfirmDialog
      size="small"
      title="You are now leaving AP Classroom"
      onClose={onClose}
      onSuccess={onSuccess}
      isPrimaryBtnDisabled={isPrimaryBtnDisabled}
      content={{
        btnSecondary: 'Cancel',
        btnPrimary: 'Continue',
        bottomLeftContent,
      }}
    >
      <div className={className}>
        You are now leaving AP Classroom and are going to JSTOR.org, which is a
        third-party organization not related to College Board.
      </div>
      <div className={className}>
        Your use of JSTOR is subject to JSTOR's{' '}
        <a
          href="https://about.jstor.org/terms/"
          rel="noreferrer"
          target="_blank"
        >
          Terms and Conditions
        </a>{' '}
        and{' '}
        <a
          href="https://www.ithaka.org/privacypolicy/"
          rel="noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>
        .
      </div>
    </ConfirmDialog>
  );
};

JstorConfirmModal.prototype = {
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default JstorConfirmModal;
